import { render, staticRenderFns } from "./RsaPazienteRefertoModalEditComponent.vue?vue&type=template&id=2cb38d84"
import script from "./RsaPazienteRefertoModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRefertoModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports